import(/* webpackMode: "eager" */ "/var/directorder/app/main/apps/buyer/src/app/(auth)/login/[[...mode]]/page.js");
